<div [style.background-color]="background" class="p-2 tool-tip-wrapper">
  <img *ngIf="imageUrl" [src]="imageUrl" alt="" />
  <p [style.color]="color" class="p-2">{{ text }}</p>
</div>
